import { useMemo } from 'react'
import { GetStaticProps } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { NavBar, FooterLanding } from '@foros-fe/core'

export default function Rules() {
  const { t } = useTranslation('rules')
  const html = useMemo(() => ({ __html: t('content') }), [t])

  return (
    <main>
      <NavBar />
      <div className='container py-12 space-y-12'>
        <h1 className='text-center text-2xl'>{t('title')}</h1>
        <div dangerouslySetInnerHTML={html} />
      </div>
      <FooterLanding />
    </main>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ssr: true,
      ...(await serverSideTranslations(locale!, ['common', 'rules', 'enum'])),
    },
  }
}
